import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Component } from 'react';
import { getDisplayName } from 'libs/utils/react';
import TrackingContext from './TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withTracking(WrappedComponent) {
  var _class;

  return _class = class InjectTracking extends Component {
    render() {
      return /*#__PURE__*/_jsx(TrackingContext.Consumer, {
        children: trackerProps => {
          if (!trackerProps) throw new Error('Missing tracking provider');
          return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread(_objectSpread({}, this.props), {}, {
            track: trackerProps.tracker.track
          }));
        }
      });
    }

  }, _defineProperty(_class, "displayName", getDisplayName(WrappedComponent)), _defineProperty(_class, "WrappedComponent", WrappedComponent), _class;
}